import React from 'react'

export function IncentiveActiveIcon(props) {
    return (
        <>

            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.4 23.4H15.6V18.2H10.4V23.4ZM2.6 15.6H7.8V10.4H2.6V15.6ZM10.4 15.6H15.6V10.4H10.4V15.6ZM18.2 15.6H23.4V10.4H18.2V15.6ZM18.2 7.8H23.4V2.6H18.2V7.8ZM7.8 26V18.2H0V7.8H15.6V0H26V18.2H18.2V26H7.8Z" fill="#FD7D56" />
            </svg>


        </>
    )
}
